import { useEffect } from "react";
import { Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { useCreateSlackIntegrationMutation } from "../../../__generated__/graphql";
import { useCompany } from "../../../contexts/CompanyContext";
import { INTEGRATIONS } from "../../../utils/constants";
import LoadingAnimation from "../../LoadingAnimation";

const { SLACK, SLACK_REDIRECT_URI, SLACK_INTEGRATIONS_PATH } = INTEGRATIONS;

const IntegrationsSlack = () => {
  const { selectedCompany } = useCompany();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  // https://app.sailfishqa.com/settings/integrations/slack?code=6677841472737.8927582648534.4c484289fe5297846576b83b679170240733bbd37f7fdd29eea4a0c3c01fd3b8&state=
  const code = searchParams.get("code");
  // const state = searchParams.get("state");

  const [createIntegration] = useCreateSlackIntegrationMutation();

  useEffect(() => {
    const runMutation = async () => {
      if (code) {
        try {
          await createIntegration({
            variables: {
              code,
              companyId: selectedCompany
                ? parseInt(selectedCompany.value, 10)
                : undefined,
            },
          });
        } catch (error) {
          console.error("Error Integrating Slack:", error);
        } finally {
          navigate(SLACK_INTEGRATIONS_PATH);
        }
      }
    };

    runMutation();
  }, [code, createIntegration, selectedCompany, navigate]);

  // If "code" is not present, redirect back to the integrations page.
  return code ? (
    <LoadingAnimation text='Finalizing GitHub Integration...' />
  ) : (
    <Navigate to={SLACK_INTEGRATIONS_PATH} />
  );
};

export default IntegrationsSlack;

// https://slack.com/oauth/v2/authorize?scope=&amp;user_scope=&amp;redirect_uri=https%3A%2F%2Fexample.com&amp;client_id=6677841472737.8478951111956
